import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import getStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    updateChangeKeyByCalendarItemId,
    updateCalendarEntry,
    markCalendarEntryAsValid,
} from '../actions/publicActions';

mutator(updateChangeKeyByCalendarItemId, actionMessage => {
    const {
        itemId: { Id: id, ChangeKey: changeKey },
    } = actionMessage;

    const store = getStore();

    store.calendarItemIdToChangeKey.set(id, changeKey);
});

mutator(updateCalendarEntry, actionMessage => {
    const {
        itemId: { Id: id },
        calendarEntry,
    } = actionMessage;

    const store = getStore();
    const calendarEntryInStore: CalendarEntry = store.calendarEntryMapping.get(id);
    const { ItemId, ...calendarEntryWithoutItemId } = calendarEntry;

    if (calendarEntryInStore) {
        Object.keys(calendarEntryWithoutItemId).forEach(property => {
            calendarEntryInStore[property] = calendarEntryWithoutItemId[property];
        });
    }
});

mutator(markCalendarEntryAsValid, actionMessage => {
    const { calendarEntry } = actionMessage;
    const store = getStore();

    store.validEntryMapping.set(calendarEntry.ItemId.Id, true);
});
